namespace appn.views.shared.userAudit {
    class InitArgs {
        forProviderId: number = 0;
    }

    let _initArgs: InitArgs;
    let _dataTableUserAudit: any = null;

    export function init(args: InitArgs): void {
        _initArgs = args;

        initUserAuditTable();
    }

    function initUserAuditTable(): void {
        _dataTableUserAudit = appn.dataTable.create('.userAuditTable', {
            sDom: appn.dataTable.genSDom(0, 0, 1),
            scrollX: '100%',
            sAjaxSource: '../UserAuditDataTable',
            fnServerData: function(data: any) {
                data.push(appn.dataTable.getStateOrDefault('sCustom_0', $('#sCustom_0').prop('checked')),
                    appn.dataTable.getStateOrDefault('sCustom_1', _initArgs.forProviderId));
            },
            aLengthMenu: [10, 25, 50, 100],
            iDisplayLength: 50,
            aaSorting: [[4, 'desc']],
            aoColumns: getDtColConfiguration(),
            fnInitComplete: function() {
                $('.dataTables_filter').prepend(appn.elementBuilder.buildCheckbox(T('Include Invited Users'), 'saveMeState', 'sCustom_0'));
                appn.dataTable.addSearchPlaceholder(T('Filter results where any column contains a keyword typed in here.'));
                appn.saveMeState.init(function(): any {
                    _dataTableUserAudit.fnDraw(false);
                },
                function(): any {
                    _dataTableUserAudit.fnDraw(false);
                }, '.dataTables_filter');
            }
        });
    }

    function getDtColConfiguration(): Array<any> {
        return [
            { bSortable: true, sWidth: '10%' },
            { bSortable: true, sWidth: '25%' },
            { bSortable: true, sWidth: '10%' },
            { bSortable: true, sWidth: '10%' },
            { bSortable: true, sWidth: '10%' },
            { bSortable: true, sWidth: '10%' },
            { bSortable: true, sWidth: '25%' }
        ];
    } 
}
